// extracted by mini-css-extract-plugin
module.exports = {"base":"SearchInput_base__1Vdjl"};